import { c as _c } from "react/compiler-runtime";
import { Button, Link } from "@opensea/next-ui-kit";
import { CenterAligned, Container, FlexCenter, FlexColumn, SpaceBetween, TextBody, TextDisplay } from "@opensea/ui-kit";
import { OpenSeaBrandLogo, OpenSeaLetters } from "@opensea/ui-kit/icons";
import { useAccountStates } from "@opensea/wallet";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { AccountSwitcherDropdown } from "@/components/navigation/top-nav/account-switcher/AccountSwitcherDropdown";
import { ProfileButton } from "@/components/navigation/top-nav/ProfileButton";
import { SUPPORT_URL, TERMS_OF_SERVICE_URL } from "@/constants/constants";
import { useAddress } from "@/hooks/wallet";
export function AccountBannedPage() {
  const $ = _c(12);
  const t = useTranslations("AccountBannedPage");
  const [accountSwitcherOpen, setAccountSwitcherOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <FlexCenter className="gap-2.5"><OpenSeaBrandLogo size={30} /><OpenSeaLetters className="h-8 translate-y-0.5" width={107} /></FlexCenter>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== accountSwitcherOpen) {
    t1 = <SpaceBetween>{t0}<AccountSwitcherDropdown onOpenChange={setAccountSwitcherOpen}><ProfileButton dropdownOpen={accountSwitcherOpen} /></AccountSwitcherDropdown></SpaceBetween>;
    $[1] = accountSwitcherOpen;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <AccountBannedHeading />;
    t3 = <AccountBannedDescription />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("visitHelpCenter");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <CenterAligned className="mx-auto h-[60vh] max-w-[700px]"><FlexColumn className="items-center gap-6 text-center">{t2}{t3}<Button href={SUPPORT_URL} variant="tertiary">{t4}</Button></FlexColumn></CenterAligned>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t1 || $[10] !== t5) {
    t6 = <Container className="py-4">{t1}{t5}</Container>;
    $[9] = t1;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function AccountBannedHeading() {
  const $ = _c(7);
  const t = useTranslations("AccountBannedPage");
  const accountStates = useAccountStates();
  const accountState = accountStates[0];
  let t0;
  if ($[0] !== accountState || $[1] !== t) {
    t0 = function getText() {
      switch (accountState) {
        case "STATE_100":
          {}
        case "STATE_200":
          {}
        case "STATE_500":
          {
            return t("accountDisabled");
          }
        default:
          {
            return t("accountUnavailable");
          }
      }
    };
    $[0] = accountState;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const getText = t0;
  let t1;
  if ($[3] !== getText) {
    t1 = getText();
    $[3] = getText;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <TextDisplay size="lg">{t1}</TextDisplay>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function AccountBannedDescription() {
  const $ = _c(11);
  const t = useTranslations("AccountBannedPage");
  const address = useAddress();
  const accountStates = useAccountStates();
  const accountState = accountStates[0];
  let t0;
  if ($[0] !== t) {
    t0 = t.rich("supportMessage", {
      link: _temp
    });
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TextBody>{t0}</TextBody>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const defaultSupportParagraph = t1;
  let t2;
  if ($[4] !== accountState || $[5] !== address || $[6] !== defaultSupportParagraph || $[7] !== t) {
    t2 = function renderText() {
      switch (accountState) {
        case "STATE_100":
          {
            return <><TextBody>{t.rich("disabledViolation", {
                  terms: _temp2
                })}</TextBody>{defaultSupportParagraph}</>;
          }
        case "STATE_1000":
          {
            return <><TextBody>{t.rich("disabledViolationCollections", {
                  terms: _temp3
                })}</TextBody>{defaultSupportParagraph}</>;
          }
        case "STATE_500":
          {
            return <><TextBody>{t.rich("disabledViolationNotVisible", {
                  terms: _temp4
                })}</TextBody><TextBody>{t("collectionsNoLongerVisible")}</TextBody>{defaultSupportParagraph}</>;
          }
        default:
          {
            return <><TextBody>{t("accountUnavailableMessage", {
                  address: address || ""
                })}</TextBody><TextBody>{t("appreciatePatience")}</TextBody></>;
          }
      }
    };
    $[4] = accountState;
    $[5] = address;
    $[6] = defaultSupportParagraph;
    $[7] = t;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const renderText = t2;
  let t3;
  if ($[9] !== renderText) {
    t3 = <FlexColumn className="gap-2 text-text-secondary">{renderText()}</FlexColumn>;
    $[9] = renderText;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function _temp4(children_0) {
  return <Link href={TERMS_OF_SERVICE_URL}>{children_0}</Link>;
}
function _temp3(children_1) {
  return <Link href={TERMS_OF_SERVICE_URL}>{children_1}</Link>;
}
function _temp2(children_2) {
  return <Link href={TERMS_OF_SERVICE_URL}>{children_2}</Link>;
}
function _temp(children) {
  return <Link href={SUPPORT_URL}>{children}</Link>;
}